"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfirmEmailRegisterFormTranslate = void 0;
exports.defaultConfirmEmailRegisterFormTranslate = {
    required: 'Required',
    nameSubmit: 'Submit',
    phoneFormat: 'Invalid Phone Format',
    emailRequired: 'Email Required',
    firstnameRequired: 'First Name Required',
    lastnameRequired: 'Last Name Required',
    phoneBodyRequired: 'Phone Number Required',
    passwordRequired: 'Password is required',
    passwordStrength: 'Password is too weak',
    passwordConfirmRequired: 'You have to confirm your password',
    passwordNotEquals: 'The repeated password does not match the above',
    placeholderFirstName: 'First Name (eg. John)',
    placeholderLastName: 'Last Name (eg. Doe)',
    placeholderPhoneBody: 'Phone Number (eg. 21020888)',
    placeholderPassword: 'Password',
    placeholderPasswordConfirm: 'Repeat your Password',
    nameRegisterTermsCaption: 'Register implies agreeing to our terms and conditions',
    nameRegisterAsteriskAreRequired: '* Field is required',
    placeholderUpdate: 'Subscribe to market update',
};
